import styled from '@emotion/styled';

export const H3 = styled.h3`
  font-weight: bold;
  font-size: 20px;

  line-height: 1.4;

  margin-top: 1.5em;
`;



// WEBPACK FOOTER //
// ./src/components/H3/H3.js